import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { PAYMENTS_INCOMING_ACH_BASE_PATH } from '../../../../../../../../../features/payments/incoming-ach/payments-incoming-ach-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-ach/_incoming-ach')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'incoming-ach-payment-list',
        label: 'Payments',
        to: PAYMENTS_INCOMING_ACH_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
